export enum RoomError {
  FORBIDDEN = 1403,
  NOT_FOUND = 1404,
  NEXT_LIVE_TOO_EARLY = 1425
}
